export const REVIEW_SUMMARY = {
  rating: 4.9,
  reviewCount: 230,
  googleMapsUrl: "https://www.google.com/maps",
  sample: true,
};

// NOTE: Clearly labelled as sample data until backend integration.
export const SAMPLE_REVIEWS = [
  {
    id: "r1",
    reviewerName: "Wei Ming L.",
    rating: 5,
    text:
      "Booked their post-reno cleaning for our new BTO. The team was punctual, thorough and left the unit spotless. Definitely recommend.",
    publishedAt: "2025-11-18",
  },
  {
    id: "r2",
    reviewerName: "Priya S.",
    rating: 5,
    text:
      "Excellent end-of-tenancy service. Landlord had no complaints and I got my deposit back in full.",
    publishedAt: "2025-10-02",
  },
  {
    id: "r3",
    reviewerName: "Daniel T.",
    rating: 5,
    text:
      "Deep floor cleaning made a huge difference to our marble floors. Professional, clean process, and very good pricing.",
    publishedAt: "2025-09-14",
  },
];
